import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {setSaveNewCard} from "../../../../_reducers/activitySlice";
import moment from "moment";
import {setNewCard} from "../../../../_reducers/DataPanel/Cash/cashSlice";
import {cardTypeOptions, checkPermissionStartingTree} from "../../../../_helpers/commonFunctions";
import Input from "../../../common/Input";
import {Col, Row} from "react-bootstrap";
import Dropdown from "../../../primer/Dropdown";
import TextArea from "../../../common/TextArea";
import BetterCheckBox from "../../../common/BetterCheckBox";

const CardsNew = () => {
    const dispatch = useDispatch();
    const saveNewCard = useSelector((state) => state.ACTIVITY.saveNewCard);
    const newCard = useSelector((state) => state.CASH_DATA.newCard);

    const permissionsData = JSON.parse(localStorage.getItem("permissions"));

    const handleOnChange = (e, type, name) => {
        if (!saveNewCard) dispatch(setSaveNewCard(true));

        const prepChange = {};
        if (type === "dd") {
            prepChange[name] = e.value;
        } else if (type === "db") {
            if (moment(e).isValid()) prepChange[name] = moment(e).toDate();
            else prepChange[name] = "";
        } else if (type === "ab") {
            let val = e.target.value;
            if (isNaN(+val) || +val <= 0) val = 0;
            else val = +Number(val).toFixed(2);
            prepChange[name] = val;
        } else if (type === "input") {
            if (name === "numbering") {
                prepChange[name] = e.target.value.replace(/\D/g, '').slice(0, 16);
            } else {
                prepChange[name] = e.target.value;
            }
        } else if (type === "cb-active") {
            prepChange[name] = e.target.checked ? "active" : "inActive";
        }
        dispatch(setNewCard({...newCard, ...prepChange}));
    }

    return (
        <div>
            <Row className={"mb-3"}>
                <Col md={3}>
                    <Dropdown
                        name={"type"}
                        label={"Τύπος Κάρτας"}
                        key={Math.random()}
                        options={cardTypeOptions}
                        required={true}
                        defaultValue={cardTypeOptions.find((el) => el.value === newCard.type)}
                        onChange={(e) => handleOnChange(e, "dd", "type")}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        name={"name"}
                        label={"Ονομασία κάρτας"}
                        value={newCard.name}
                        autoComplete={"off"}
                        required={true}
                        onChange={(e) => handleOnChange(e, "input", "name")}
                    />
                </Col>
                <Col md={4}>
                    <Input
                        name={"numbering"}
                        label={"Αριθμός Κάρτας"}
                        value={newCard.numbering}
                        autoComplete={"off"}
                        required={true}
                        type={"text"}
                        inputMode={"numeric"}
                        onChange={(e) => handleOnChange(e, "input", "numbering")}
                    />
                </Col>
                <Col md={2} className={"d-flex justify-content-end"}>
                    <div style={{marginTop: "28px"}}>
                        <BetterCheckBox
                            name={"isActive"}
                            text={"Ενεργή"}
                            checked={newCard.isActive === "active"}
                            onChange={(e) => handleOnChange(e, "cb-active", "isActive")}
                        />
                    </div>
                </Col>
                <Col md={12}>
                    <TextArea
                        name={"notes"}
                        label={"Σημειώσεις"}
                        rows={4}
                        value={newCard.notes}
                        onChange={(e) => handleOnChange(e, "input", "notes")}
                    />
                </Col>
            </Row>
            {checkPermissionStartingTree("accounting", permissionsData) && (
                <React.Fragment>
                    <hr/>
                    <div className="text-muted mb-2"><i>Λογιστική</i></div>
                    <Row className={"mb-3"}>
                        <Col md={4}>
                            <Input
                                name={"accounting"}
                                label={"Πρόθεμα Λογιστικού Λογαριασμού"}
                                value={newCard.accounting}
                                autoComplete={"off"}
                                onChange={(e) => handleOnChange(e, "input", "accounting")}
                            />
                        </Col>
                        <Col md={4}>
                            <Input
                                name={"bypassAccounting"}
                                label={"Κωδικός Λογαριασμού Παράκαμψης Λογιστικής Γέφυρας"}
                                value={newCard.bypassAccounting}
                                autoComplete={"off"}
                                onChange={(e) => handleOnChange(e, "input", "bypassAccounting")}
                            />
                        </Col>
                    </Row>
                </React.Fragment>
            )}
        </div>
    )
}

export default CardsNew;
